export default "/images/vendor/@coreui/icons/svg/flag/cif-lk.svg?8acb1ecc3e91041b4f05ac58ec6c8c02";